import Keycloak from 'keycloak-js'

let client

export function initialize ({ authUrl, realm, clientId }) {
  client = new Keycloak({
    url: authUrl,
    realm: realm,
    clientId: clientId
  })
}

export async function login () {
  return !client.authenticated ? client.init({ onLoad: 'login-required' }) : client.authenticated }

export function logout () {
  return client.logout({ redirectUri: window.location.origin }) }

export function isAuthenticated () { return client ? client.authenticated : false }

export async function getToken () {
  await client.updateToken(5)
  return client.token
}
